import React, { useState, useEffect } from "react";
import { fetchClasses } from "../utils/classesApi";
import { motion } from "framer-motion";

const cardVariants = {
  hidden: { opacity: 0, scale: 0.9, y: 30 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" },
  },
};

export default function Classes() {
  const [classDetails, setClassDetails] = useState([]);

  useEffect(() => {
    fetchClasses().then((data) => setClassDetails(data || []));
  }, []);

  return (
    <div className="overflow-hidden">
      <div className="container-fluid pt-5">
        <div className="container">
          <motion.div 
            className="text-center pb-2"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <p className="section-title px-5">
              <span className="px-2">Popular Classes</span>
            </p>
            <h1 className="mb-4">Classes for Your Kids</h1>
          </motion.div>
          
          <div className="row">
            {classDetails.map((el, idx) => (
              <motion.div 
                className="col-lg-4 mb-5" 
                key={el.id || idx}
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.1 }}
              >
                <div className="card border-0 bg-light shadow-sm pb-2 h-100 hover-zoom">
                  <div className="card-body text-center">
                    <h4 className="card-title mb-0">{el.name}</h4>
                    <p className="card-text text-primary font-weight-bold">{el.title}</p>
                  </div>
                  <div className="card-footer bg-transparent py-4 px-5">
                    <div className="row border-bottom">
                      <div className="col-6 py-1 text-right border-right">
                        <strong>Age of Kids</strong>
                      </div>
                      <div className="col-6 py-1">{el.ageRange} Years</div>
                    </div>
                    <div className="row border-bottom">
                      <div className="col-6 py-1 text-right border-right">
                        <strong>Total Seats</strong>
                      </div>
                      <div className="col-6 py-1">{el.seats} Seats</div>
                    </div>
                    <div className="row border-bottom">
                      <div className="col-6 py-1 text-right border-right">
                        <strong>Class Time</strong>
                      </div>
                      <div className="col-6 py-1">{el.classTime || el.calssTime}</div>
                    </div>
                    <div className="row">
                      <div className="col-6 py-1 text-right border-right">
                        <strong>Tuition Fee</strong>
                      </div>
                      <div className="col-6 py-1">{el.tuitionFee || el.tutionFee} / Month</div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
